import type { Table } from '@wmt/content-blocks'

export const getSortAsNumber = <DataT>(_index: number, cell: Table.BodyCell<DataT> | Table.Cell<DataT>): number | string => {
  return cell.content ? parseFloat(cell.content as string) : 0
}
